module.exports = __webpack_public_path__ + "img/shiba-loading.c801a5c4.png";